import React, { useState } from "react";
import {
  Button,
} from '../../ui-components';
import {
  FeatureTitle,
  Wrapper,
  Container,
} from './features.styled';
import Gallery from "../gallery/gallery";
import GalleryFullScreen from "../gallery/gallery-fullscreen"


const FeaturesEtrailer = ({ gallery }) => {
  const [fullScreenIndex, setFullScreenIndex] = useState(null);
  const data = [
    {
      "type": "youtube",
      "youtube": "https://www.youtube.com/embed/0VBTVt8v5i4"
    }
  ]
  const fullScreenData = fullScreenIndex !== null ? data[fullScreenIndex] : null;

  const enterFullScreen = () => {
    setFullScreenIndex(0);
  }

  const handleClose = (event) => {
    event.preventDefault();
    setFullScreenIndex(null);
  }

  return (
    <>
      {fullScreenData
        ? (
          <GalleryFullScreen
            data={{
              type: fullScreenData.type,
              youtube: fullScreenData.youtube,
            }}
            disableNavigation
            onNext={() => { }}
            onPrev={() => { }}
            onClose={handleClose}
            forcedType="youtube"
          />
        )
        : ''}

      <Wrapper>
        <a name="product" />
        <Container>
          <FeatureTitle>Amphibious Camper - eTrailer</FeatureTitle>
        </Container>

        <Container center margin>
          <Button
            type="button"
            onClick={enterFullScreen}
            target="_blank"
            size="large"
            color="primary"
          >
            Demo Video
          </Button>
          &nbsp;
          <Button
            type="anchor"
            to="/BeTRITON_eTrailer_Brochure.pdf"
            target="_blank"
            size="large"
            color="primary"
          >
            Brochure
          </Button>
          &nbsp;
          <Button
            type="anchor"
            to="/BeTRITON_eTrailer_Config-Options-Pricing.pdf"
            target="_blank"
            size="large"
            color="secondary"
          >
            Pricing
          </Button>
        </Container>

        <br />

        <Container>
          <Gallery data={gallery} />
        </Container>

      </Wrapper>
    </>
  )
}

export default FeaturesEtrailer;
